module.exports = {"admin":"Administrator","readOnly":"Schreibgeschützt","accounting":"Buchhaltung"}